module.exports = __webpack_public_path__ + "static/media/portfolio.7fdd7929.jpg";